import { observer } from 'mobx-react-lite'
import { NoteTemplatesShadcnComponent } from 'app/components/note-templates/NoteTemplatesShadcnComponent'
import { useNoteTemplates } from 'app/components/note-templates/useNoteTemplates'

// The Notes tab of the templates hub (/settings/templates).
const SettingsTemplatesNotes = observer(function SettingsTemplatesNotes() {
  const props = useNoteTemplates()
  return <NoteTemplatesShadcnComponent {...props} />
})

export default SettingsTemplatesNotes
